import { render, staticRenderFns } from "./settlement-discount-gift.vue?vue&type=template&id=71a82f8d&scoped=true"
import script from "./settlement-discount-gift.vue?vue&type=script&lang=js"
export * from "./settlement-discount-gift.vue?vue&type=script&lang=js"
import style0 from "./settlement-discount-gift.vue?vue&type=style&index=0&id=71a82f8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a82f8d",
  null
  
)

export default component.exports